import { cn } from '@/lib/utils'
import type { LogoVariant } from '@/types'

interface Props {
  url: string | null
  name: string
  variant: LogoVariant | null
  className?: string
}

// Shared logo renderer. The variant (computed at upload) decides whether to
// place the image on a contrasting plate so dark-on-dark or light-on-light
// never becomes invisible. Caller controls size / radius via `className`.
export function OrgLogo({ url, name, variant, className }: Props) {
  if (!url) {
    return (
      <div
        className={cn(
          'bg-muted flex items-center justify-center shrink-0 font-semibold text-muted-foreground',
          className
        )}
      >
        {name.slice(0, 1).toUpperCase()}
      </div>
    )
  }

  const plate =
    variant === 'dark' ? 'bg-white p-0.5' :
    variant === 'light' ? 'bg-neutral-900 p-0.5' :
    ''

  return (
    <div
      className={cn(
        'shrink-0 overflow-hidden flex items-center justify-center',
        plate,
        className
      )}
    >
      <img src={url} alt={name} className="w-full h-full object-contain" />
    </div>
  )
}
